import { render } from "./nodoubtvegas.vue?vue&type=template&id=3816c6fb"
import script from "./nodoubtvegas.vue?vue&type=script&lang=js"
export * from "./nodoubtvegas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__